import React from 'react';
import { motion } from 'framer-motion';

export const GlassCard = ({ children, className = '', hover = false, ...props }) => {
  const baseClasses = 'bg-white/[0.03] backdrop-blur-md border border-white/[0.05] rounded-2xl md:rounded-3xl shadow-2xl shadow-black/50 p-6';
  const hoverClasses = hover ? 'hover:bg-white/[0.06] hover:border-white/[0.1] transition-all duration-300' : '';
  
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className={`${baseClasses} ${hoverClasses} ${className}`}
      {...props}
    >
      {children}
    </motion.div>
  );
};